module.exports = __webpack_public_path__ + "img/流程设计_01.671fc9b3.svg";